import React from 'react'
import {EntityLink} from 'common/Links'
import {SubscribeUserButton, InviteUserButton} from 'common/buttons'
import Avatar from 'common/Avatar'

export function UserItem({as, renderButton, ...props}: any)
{
	const ComponentName = as || 'li'
  const {user} = props
	const {username, fullname} = user

	return (
    <ComponentName
      className="list-group-item"
    >
      <div className="row align-items-center">
        <div className="col-auto">
          <Avatar user={user}/>
        </div>
        <div className="col ml-n2">
          <h4 className="mb-1">
            <EntityLink to={user}>
              {fullname}
            </EntityLink>
          </h4>
          <p className="small text-muted mb-0">
            <EntityLink to={user} className="d-block text-reset text-truncate">
              @{username}
            </EntityLink>
          </p>
        </div>
        {renderButton && renderButton(props)}
      </div>
    </ComponentName>
	)
}

export const UserItemWithSubscription = (props: any) => (
  <UserItem
    {...props}
    renderButton={({user}: any) => (
      <div className="col-auto">
          <SubscribeUserButton user={user}/>
      </div>
    )}
  />
)

export const UserItemWithParticipation = (props: any) => (
  <UserItem
    {...props}
    renderButton={({user, adventure}: any) => (
      <div className="col-auto">
          <InviteUserButton user={user} adventure={adventure}/>
      </div>
    )}
  />
)

export function AdventureItem({adventure}: any)
{
	return (
		<p>Working on it</p>
	)
}
